<ng-container *ngIf="viewModel$ | async as vm">
  <app-cp-reports-main-card></app-cp-reports-main-card>
  <div class="container-comparison-savings">
    <app-cp-reports-energy-savings-card class="savings-card" *ngIf="vm.report.savings_in_percentage !== undefined"></app-cp-reports-energy-savings-card>
    <app-cp-reports-comparison-with-other-homes-card class="comparison-card"  *ngIf="vm.report?.heating_time_compared_to_similar_houses_graph_data?.heating_time_similar_houses_points && ( vm.report?.total_heating_time / 3600 >= 1 && (vm.report.home_size && vm.report.heating_time_compared_to_similar_houses_in_percentage > 0 || !vm.report.home_size))"></app-cp-reports-comparison-with-other-homes-card>
  </div>

</ng-container>
